import { render, staticRenderFns } from "./favorite.vue?vue&type=template&id=1425203a&"
import script from "./favorite.vue?vue&type=script&lang=js&"
export * from "./favorite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports